import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  card: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, UiAlpha.Subtle)}`,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  buttonsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
  },
  linkButton: {
    flex: '1 1 auto',
    minWidth: 140,
  },
}));
